<template>
  <div class="landing-page-search">
    <div class="landing-page__container">
      <div class="landing-page-search__content">
        <div class="landing-page-search__text">
          <h2 class="landing-page__title landing-page__title_bold landing-page-search__title">
            {{ $t('landingPage.fastSearch.title') }}
          </h2>
          <div class="landing-page-search__desc">
            {{ $t('landingPage.fastSearch.description') }}
            <div>
              {{ $t('landingPage.fastSearch.info') }}
            </div>
          </div>
        </div>
        <steps />
      </div>
    </div>
  </div>
</template>

<script>
import steps from '@/components/landing/steps';

export default {
  name: 'FastSearch',
  components: {
    steps,
  },
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

  .landing-page-search {
    padding-top: 105px;
    padding-bottom: 160px;
    background-size: cover;
    text-align: center;
    background: #266ef4 url("../../assets/images/landing/bg-search.jpg") no-repeat;
    color: $color-white;
    background-size: cover;

    &__title {
      text-align: left;
      margin-left: 27px;
      margin-bottom: 10px;
    }

    &__text {
      margin-right: 94px;
      max-width: 680px;
      min-width: 680px;
      width: 100%;
    }

    &__content {
      display: flex;
      justify-content: space-between;
      width: 100%;
      position: relative;
    }

    &__desc {
      font: $font-size-landing-lg $font-landing-global;
      color: $color-white;
      margin-top: 8px;
      line-height: 1.5;
      text-align: left;
      margin-left: 32px;
      letter-spacing: .2px;

      div {
        font-size: $font-size-icon-sm;
        max-width: 510px;
        margin-top: 21px;
        line-height: 1.4;
        margin-bottom: 45px;
      }
    }
  }

@include tablet-old {
  .landing-page-search {
    &__text {
      min-width: 460px;
      max-width: 460px;
    }

    &__title, &__desc {
      margin-left: 0;
    }
  }
}

@include tablet-portrait {
  .landing-page-search {
    padding-top: 70px;
    padding-bottom: 140px;

    &__desc {
      font-size: $font-size-landing-md;
      text-align: center;

      div {
        max-width: 100%;
        text-align: center;
        margin-bottom: 30px;
      }
    }

    &__title {
      text-align: center;
    }

    &__content {
      flex-direction: column;
    }

    &__text {
      margin-right: 0;
      min-width: auto;
      max-width: none;
    }
  }
}

@include mobile {
  .landing-page-search {
    padding-top: 50px;
    min-height: auto;
    padding-bottom: 100px;

    &__desc {
      font-size: $font-size-base;
      margin-top: 12px;
      line-height: 1.4;
    }
  }
}
</style>
